import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ScrollToTop, ErrorBoundary, TeleScript, getCMSObject } from 'sg-ui-components';

import { createStore } from './Store';

import HomePage from './pages/home';
import PromotionsPage from './pages/promotions';
import PromotionsMobilePage from './pages/promotionsMobile';
import PromotionDetailsPage from './pages/promotionDetails';
import FeedbackPage from './pages/feedback';
import TermsPage from './pages/terms';
import PrivacyPage from './pages/privacy';
import WinnersPage from './pages/winners';
import LoginPage from './pages/login';
import ForgotPasswordPage from './pages/forgotPassword';
import RecoverPasswordPage from './pages/recoverPassword';
import MyActivityPage from './pages/myActivity';
import MyProfilePage from './pages/myProfile';
import RegisterPage from './pages/register';
import AccountConfirmPage from './pages/accountConfirm';
import EnterPage from './pages/enter';
import PasswordExpiringPage from './pages/passwordExpiring';
import PasswordExpiredPage from './pages/passwordExpired';
import PostClaimPage from './pages/postClaim';
import LogoutPage from './pages/logout';
import PageNotFound from './pages/404';

import './styling/global.scss';

const app = document.getElementById('root');

const errorBoundaryTelescript = getCMSObject('data.messages.pageErrorMessages.jsonBlock');

render(
    <Provider store={createStore()}>
        <ErrorBoundary fallback={<TeleScript line={errorBoundaryTelescript?.rootFallback} />} details={{}}>
            <Router basename='/'>
                <ScrollToTop />
                <main id='main-content'>
                    <Suspense fallback={<div>Loading...</div>}>
                        <Switch>
                            <Route exact path='/' component={HomePage} />
                            <Route path='/home' component={HomePage} />

                            <Route path='/login' component={LoginPage} />
                            <Route path='/forgot-password' component={ForgotPasswordPage} />
                            <Route path='/recover-password' component={RecoverPasswordPage} />
                            <Route path='/register' component={RegisterPage} />
                            <Route path='/account-confirm' component={AccountConfirmPage} />
                            <Route path='/password-expiring' component={PasswordExpiringPage} />
                            <Route path='/password-expired' component={PasswordExpiredPage} />
                            <Route path='/logout' component={LogoutPage} />

                            <Route path='/promotions' component={PromotionsPage} />
                            <Route path='/promotion-mobile' component={PromotionsMobilePage} />
                            <Route path='/promotion' component={PromotionDetailsPage} />
                            <Route path='/enter' component={EnterPage} />
                            <Route path='/post-claim' component={PostClaimPage} />

                            <Route path='/my-activity' component={MyActivityPage} />
                            <Route path='/my-profile' component={MyProfilePage} />
                            <Route path='/winners' component={WinnersPage} />
                            <Route path='/feedback' component={FeedbackPage} />
                            <Route path='/terms' component={TermsPage} />
                            <Route path='/privacy' component={PrivacyPage} />

                            <Route path='*' component={PageNotFound} />
                        </Switch>
                    </Suspense>
                </main>
            </Router>
        </ErrorBoundary>
    </Provider>,
    app
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
